import { makeStyles } from '@mui/styles';

export const useInviteLandingStyles = makeStyles({
  root: {
    flexGrow: 1,
    height: '95%',
    maxWidth: '100%'
  },
  Heading: {
    marginBottom: '0.5em'
  },
  InviteCard: {
    backgroundColor: '#FFFFFF',
    padding: '3em',
    // minWidth: "480px",
    minHeight: '60%',
    maxWidth: '100%',
    flexGrow: 1
  },
  MaxWidth: {
    maxWidth: '100%',
    paddingTop: '2em'
  },
  Footer: {
    paddingTop: '3%'
  }
});
